import {get} from 'lodash';
import schema from './subprofile_db';
import * as utils from "./utils";
import {edit} from './sample';
import * as Profile from './profile';
import i18n from 'src/i18n/index';
import debug from 'src/debug';

export function title(model) {
  let a = get(model, 'details.profile');
  return a ? Profile.title.call(this, a, Profile) : '';
}

export const columns = utils.columnsFn(schema);

/**
 * @param {int} skip default 0
 * @param {int} limit default 20
 * @param {Array<{prop: String, desc: boolean}>} sort column name
 * @param {String} search query
 * @return {Promise<{total: Number, data: Array}>}
 */
export const list = utils.listFn('getSubprofiles');
export const view = utils.viewFn('/admin/subprofiles/:id');
export const read = utils.readFn('getSubprofileById', 'subprofile_id');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      action: utils.updateFn('updateSubprofile', 'subprofile_id', [
        'status',
        'type',
        'tags',
        'details',
      ]),
    });
    if (debug.DEBUG) {
      temp.push({
        label: i18n.fr('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: e => e.keyCode === 46,
        action: utils.formActions.delete('deleteSubprofileById', 'subprofile_id', '/admin/subprofiles'),
      });
    }
  }
  temp.push({
    label: i18n.fr('action.create_$obj', {obj: '${i18n.schema.order}'}),
    class: 'btn-info',
    validation: false,
    action(model, schema) {
      this.$router.push(`/admin/orders/create?member_id=${get(model, 'creator.member_id')}&subprofile_id=${get(model, 'subprofile_id')}`);
      return Promise.resolve();
    },
  });
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/subprofile.js